// extracted by mini-css-extract-plugin
export default {"message":"Offline_message__Bq9nP"};